import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "hidden lg:block w-next-nav fixed h-menu bg-next-dark-gray z-10" }
const _hoisted_2 = { class: "grid grid-rows-7 h-full" }
const _hoisted_3 = { class: "flex-grow grid grid-rows-6 row-span-6" }
const _hoisted_4 = { class: "flex flex-col text-white text-4xl pl-12 pt-14" }
const _hoisted_5 = { class: "py-4" }
const _hoisted_6 = { class: "py-4" }
const _hoisted_7 = { class: "py-4" }
const _hoisted_8 = { class: "py-4" }
const _hoisted_9 = { class: "py-4" }
const _hoisted_10 = { class: "py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_ProfileMenuButton = _resolveComponent("ProfileMenuButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_MenuButton, {
          to: {name:'Home', params: {id: _ctx.id}},
          "icon-class": "icon-home",
          tooltip: "Home"
        }, null, 8, ["to"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_MenuButton, {
            to: {name:'ListaProgetti', params: {id: _ctx.id}},
            "icon-class": "icon-catena_orizzontale",
            tooltip: "Progetti"
          }, null, 8, ["to"]),
          _createVNode(_component_MenuButton, {
            to: {name:'ListaSottoProgetti', params: {id: _ctx.id}},
            "icon-class": "icon-catena_verticale",
            tooltip: "Sottoprogetti"
          }, null, 8, ["to"]),
          (_ctx.showPianoFatturazione)
            ? (_openBlock(), _createBlock(_component_MenuButton, {
                key: 0,
                to: {name:'ListaPianoDiFatturazione', params: {id: _ctx.id}},
                "icon-class": "icon-euro_frecce",
                tooltip: "Piano di fatturazione"
              }, null, 8, ["to"]))
            : _createCommentVNode("", true),
          (_ctx.$route.meta.showSottoprogetti)
            ? (_openBlock(), _createBlock(_component_MenuButton, {
                key: 1,
                to: {name:'SottoProgettoListaFornitori', params: {id: _ctx.id}},
                "icon-class": "icon-documento_freccia",
                tooltip: "Fornitori"
              }, null, 8, ["to"]))
            : _createCommentVNode("", true),
          (_ctx.$route.meta.showSottoprogetti)
            ? (_openBlock(), _createBlock(_component_MenuButton, {
                key: 2,
                to: {name:'ListaOrdini', params: {id: _ctx.id}},
                "icon-class": "icon-carrello",
                tooltip: "Ordini"
              }, null, 8, ["to"]))
            : _createCommentVNode("", true),
          (_ctx.$route.meta.showSottoprogetti)
            ? (_openBlock(), _createBlock(_component_MenuButton, {
                key: 3,
                to: {name:'ListaOrdini', params: {id: _ctx.id}},
                "icon-class": "icon-browser",
                tooltip: "Ordini"
              }, null, 8, ["to"]))
            : _createCommentVNode("", true),
          _createVNode(_component_ProfileMenuButton, {
            class: "row-start-6",
            notification: _ctx.meCounters?.notification_counter > 0
          }, null, 8, ["notification"])
        ])
      ])
    ]),
    (_ctx.$store.state.menu_visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "md:hidden fixed z-10 inset-0 bg-gray-500 bg-opacity-90",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "self-center text-md icon-home" }, null, -1)),
              _createVNode(_component_router_link, {
                to: {name:'Dashboard'},
                class: "pl-4"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("HOME")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "self-center text-2xl fas fa-ellipsis-h" }, null, -1)),
              _createVNode(_component_router_link, {
                to: {name:'ListaProgetti'},
                class: "pl-4"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Progetti")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "self-center text-2xl icon-opzioni" }, null, -1)),
              _createVNode(_component_router_link, {
                to: {name:'ListaSottoProgetti'},
                href: "#",
                class: "pl-4"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Sottoprogetti")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[8] || (_cache[8] = _createElementVNode("i", { class: "self-center text-2xl fas fa-file-export" }, null, -1)),
              _createVNode(_component_router_link, {
                to: {name:'ListaBudget'},
                href: "#",
                class: "pl-4"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("Budget")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[10] || (_cache[10] = _createElementVNode("i", { class: "self-center text-2xl fas fa-shopping-cart" }, null, -1)),
              _createVNode(_component_router_link, {
                to: {name:'ListaOrdini'},
                href: "#",
                class: "pl-4"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("Ordini")
                ])),
                _: 1
              })
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "py-4" }, [
              _createElementVNode("i", { class: "self-center text-2xl far fa-credit-card" }),
              _createElementVNode("a", {
                href: "#",
                class: "pl-4"
              }, "boh")
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              _cache[12] || (_cache[12] = _createElementVNode("i", { class: "self-center fa fa-circle text-md" }, null, -1)),
              _createVNode(_component_router_link, {
                to: {name:'ProfiloUtente'},
                class: "pl-4"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("PROFILO")
                ])),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}